/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AppUsageEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const appUsageEntryPoint: EntryPoint<AppUsageEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction<AppUsageEntryPointComponent>(
		/* webpackChunkName: "async-insight-global-configuration-app-usage-main" */ './AppUsageAppUsage.tsx',
	),
	getPreloadProps: () => ({}),
});
